import {
  CheckboxSettings,
  EmailSettings,
  GroupSettings,
  PageSettings,
} from "@tree-company/tree-query";
import { PageComponent } from "../components/page";
import { translationFromKey } from "./helpers";
import Markdown from "react-markdown";

export function markdownTranslations(key: string) {
  const translations = translationFromKey(key);
  for (const key in translations) {
    translations[key] = (
      <Markdown
        components={{
          a({ children, ...props }) {
            const url = new URL(props.href ?? "", location.href);
            if (url.origin !== location.origin) {
              props.target = "_blank";
              props.rel = "noopener noreferrer";
            }

            return <a {...props}>{children}</a>;
          },
        }}
      >
        {translations[key]}
      </Markdown>
    );
  }

  return translations;
}

const terms_and_privacy: CheckboxSettings = {
  type: "checkbox",
  key: "terms_and_privacy",
  order: 0,
  title: markdownTranslations("questions.terms_and_privacy.text"),
  required: true,
};

const subscribe: CheckboxSettings = {
  type: "checkbox",
  key: "optinProject",
  order: 1,
  title: translationFromKey("questions.subscription.optin_project.text"),
};

const email_results: CheckboxSettings = {
  type: "checkbox",
  key: "mailResults",
  order: 2,
  title: translationFromKey("questions.subscription.mail_results.text"),
};

const subscription_email: EmailSettings = {
  type: "email",
  key: "email",
  order: 3,
  title: {},
  placeholder: translationFromKey("questions.subscription.email.placeholder"),
  dependsOn: ["optinProject", "mailResults"],
  skipIf: (treesponse) =>
    !(
      treesponse.getAnswer("optinProject") ||
      treesponse.getAnswer("mailResults")
    ) ||
    // NOTE: This question should NEVER be shown to a bpact panel member
    treesponse.getAnswer("bpact_id") !== null,
  required: true,
};

const subscription_group: GroupSettings = {
  type: "group",
  key: "subscription_group",
  htmlAttributes: { class: "group--checkbox" },
  title: markdownTranslations("questions.subscription.description"),
  order: 0,
  sections: [subscribe, email_results, subscription_email],
};

export const page_privacy: PageSettings = {
  key: "page_privacy",
  title: {},
  order: 98,
  sections: [terms_and_privacy, subscription_group],
  htmlAttributes: {},
  component: PageComponent,
};
